import { type ReactElement } from 'react';
import {
  Box,
  DialogListActionRow,
  DialogListContentStack,
  DialogListSectionHeader,
  DialogSection,
  Stack,
  Text,
} from '@/ui';
import {
  projectSettingsCsvMappingFieldListSx,
  projectSettingsCsvMappingPanelActionRowSx,
  projectSettingsCsvMappingPanelContentSx,
  projectSettingsCsvMappingPanelHeaderSx,
  projectSettingsCsvMappingPanelGroupSx,
  projectSettingsCsvMappingPanelTitleSx,
  projectSettingsPanelActionRowInnerSx,
} from './projectSettingsSurfaceSx';

type ProjectCsvMappingPanelGroupProps = {
  actions: ReactElement;
  children: ReactElement;
  description?: string;
  isEmbedded: boolean;
  title: string;
  withDivider?: boolean;
};

export const ProjectCsvMappingPanelGroup = ({
  actions,
  children,
  description,
  isEmbedded,
  title,
  withDivider = false,
}: ProjectCsvMappingPanelGroupProps): ReactElement => {
  if (isEmbedded) {
    return (
      <DialogSection align="stretch" sx={projectSettingsCsvMappingPanelGroupSx(withDivider)}>
        <DialogListSectionHeader sx={projectSettingsCsvMappingPanelHeaderSx}>
          <Stack gap={description ? 'xxs' : 'none'}>
            <Text role="bodyStrong" sx={projectSettingsCsvMappingPanelTitleSx}>
              {title}
            </Text>
            {description ? (
              <Text role="body" color="textSecondary">
                {description}
              </Text>
            ) : null}
          </Stack>
        </DialogListSectionHeader>
        <DialogListContentStack flushTop sx={projectSettingsCsvMappingPanelContentSx}>
          <Box sx={projectSettingsCsvMappingFieldListSx}>{children}</Box>
        </DialogListContentStack>
        <DialogListActionRow sx={projectSettingsCsvMappingPanelActionRowSx}>
          {actions}
        </DialogListActionRow>
      </DialogSection>
    );
  }

  return (
    <Stack gap="md" sx={projectSettingsCsvMappingPanelGroupSx(withDivider)}>
      <Stack gap="none" sx={projectSettingsCsvMappingPanelHeaderSx}>
        <Stack gap={description ? 'xxs' : 'none'}>
          <Text role="body" sx={projectSettingsCsvMappingPanelTitleSx}>
            {title}
          </Text>
          {description ? (
            <Text role="body" color="textSecondary">
              {description}
            </Text>
          ) : null}
        </Stack>
      </Stack>
      <Box sx={projectSettingsCsvMappingFieldListSx}>{children}</Box>
      <Box sx={projectSettingsCsvMappingPanelActionRowSx}>
        <Box sx={projectSettingsPanelActionRowInnerSx}>{actions}</Box>
      </Box>
    </Stack>
  );
};
